module.exports = {
      id: "video-play-btn-usage",
      viewBox: "0 0 82 82",
      url: __webpack_public_path__ + "svg-sprite-a2aa2e5b3e3b70ea2fa34e79b698feaf.svg#video-play-btn",
      toString: function () {
        return this.url;
      }
    }